"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useFormElementValidation = _interopRequireDefault(require("../../hooks/useFormElementValidation"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _InputNumber = _interopRequireDefault(require("../Input/InputNumber"));

var _InputCurrency = _interopRequireDefault(require("../Input/InputCurrency"));

var _excluded = ["id", "name", "value", "label", "helper", "min", "max", "displayTooltip", "readOnly", "disabled", "required", "onChange", "onError", "className", "locale", "displayCurrency", "displaySuffix", "onKeyUp", "edgeRightValue", "edgeMinValue", "edgeMaxValue", "widthTrack"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Input component allows an user to enter data into the application.
 */
var RangeSlider = function RangeSlider(props) {
  var controlledId = props.id,
      name = props.name,
      controlledValue = props.value,
      initialLabel = props.label,
      helper = props.helper,
      min = props.min,
      max = props.max,
      displayTooltip = props.displayTooltip,
      readOnly = props.readOnly,
      disabled = props.disabled,
      required = props.required,
      onChange = props.onChange,
      onError = props.onError,
      className = props.className,
      locale = props.locale,
      displayCurrency = props.displayCurrency,
      displaySuffix = props.displaySuffix,
      onKeyUp = props.onKeyUp,
      edgeRightValue = props.edgeRightValue,
      edgeMinValue = props.edgeMinValue,
      edgeMaxValue = props.edgeMaxValue,
      widthTrack = props.widthTrack,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var singleRangeRef = _react.default.useRef(name);

  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;

  var _React$useState = _react.default.useState(controlledValue),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var tooltipRef = _react.default.useRef(null);

  var _React$useState2 = _react.default.useState(false),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  var _useFormElementValida = (0, _useFormElementValidation.default)(value, {
    required: required
  }),
      errors = _useFormElementValida[0];

  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
    id: id,
    value: value
  })),
      label = _useLabel.label;

  _react.default.useEffect(function () {
    return setValue(controlledValue || 0);
  }, [controlledValue]);

  _react.default.useEffect(function () {
    setError(errors.length > 0);

    if (typeof onError === 'function') {
      onError({
        name: singleRangeRef.current.name,
        errors: errors.length ? errors : []
      });
    }
  }, [errors, onError]);

  var getPercent = (0, _react.useCallback)(function (value) {
    return Math.round((value - min) / (max - min) * 100);
  }, [min, max]);
  (0, _react.useEffect)(function () {
    var valuePercent = getPercent(value);

    if (tooltipRef.current) {
      tooltipRef.current.style.transform = 'translateX(-50%)';
      tooltipRef.current.style.left = valuePercent + "%";
    }
  }, [value, getPercent]);

  var handleChange = function handleChange(event) {
    setValue(Number(event.target.value));
  };

  var showTooltip = function showTooltip(ref) {
    if (ref.current) {
      ref.current.style.display = 'block';
    }
  };

  var hideTooltip = function hideTooltip(ref) {
    if (ref.current) {
      ref.current.style.display = 'none';
    }
  };

  var containerClasses = (0, _clsx.default)('uk-range-slider', (helper.length > 0 || error) && 'has-helper', error && 'has-error', disabled && 'disabled', className);
  var arrowCodes = {
    up: 38,
    down: 40,
    right: 39,
    left: 37
  };

  var setCurrency = function setCurrency(data) {
    return /*#__PURE__*/_react.default.createElement(_InputCurrency.default, {
      value: Number(data),
      locale: locale,
      displayAsText: true
    });
  };

  var setSuffix = function setSuffix(data) {
    return /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
      displayAsText: true,
      value: Number(data),
      suffix: displaySuffix,
      locale: locale,
      readOnly: true
    });
  };

  var formatNumber = function formatNumber(data) {
    return /*#__PURE__*/_react.default.createElement(_InputNumber.default, {
      displayAsText: true,
      value: Number(data),
      locale: locale,
      readOnly: true
    });
  };

  var onDone = function onDone(event) {
    setValue(Number(event.target.value));

    if (typeof onChange === 'function') {
      onChange(Number(event.target.value));
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    var keyCode = event.keyCode,
        value = event.target.value;

    if (keyCode === arrowCodes.up || keyCode === arrowCodes.down || keyCode === arrowCodes.right || keyCode === arrowCodes.left) {
      setValue(Number(value));

      if (typeof onKeyUp === 'function') {
        onKeyUp(Number(value));
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__container"
  }, edgeMinValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__left-value"
  }, displayCurrency ? setCurrency(min) : displaySuffix ? setSuffix(min) : formatNumber(min)), /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__inputs",
    style: widthTrack ? {
      minWidth: widthTrack
    } : {}
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: singleRangeRef,
    type: "range",
    id: id,
    name: name,
    min: min,
    max: max,
    value: value,
    className: "range",
    disabled: disabled || readOnly,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    "aria-labelledby": "label-" + id,
    onChange: handleChange,
    onMouseOver: function onMouseOver() {
      return showTooltip(tooltipRef);
    },
    onMouseOut: function onMouseOut() {
      return hideTooltip(tooltipRef);
    },
    onFocus: function onFocus() {
      return showTooltip(tooltipRef);
    },
    onBlur: function onBlur() {
      return hideTooltip(tooltipRef);
    },
    onMouseUp: onDone,
    onTouchEnd: onDone,
    onKeyUp: handleKeyUp
  }, attributes)), displayTooltip && /*#__PURE__*/_react.default.createElement("div", {
    ref: tooltipRef,
    className: "tooltip"
  }, displayCurrency ? setCurrency(value) : displaySuffix ? setSuffix(value) : formatNumber(value))), edgeMaxValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__right-value"
  }, displayCurrency ? setCurrency(max) : displaySuffix ? setSuffix(max) : formatNumber(max)), edgeRightValue && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-range-slider__edge-value uk-range-slider__value"
  }, displayCurrency ? setCurrency(value) : displaySuffix ? setSuffix(value) : formatNumber(value))), (helper.length > 0 || error) && /*#__PURE__*/_react.default.createElement("small", {
    className: "helper"
  }, error || helper));
};

RangeSlider.propTypes = {
  /**
   * ID of the RangeSlider (used to bind the label to the Input)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Name of the RangeSlider (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,

  /**
   * Default value of the RangeSlider
   */
  value: _propTypes.default.number,

  /**
   * Label of the RangeSlider
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Minimum value of the RangeSlider
   */
  min: _propTypes.default.number,

  /**
   * Maximun value of the RangeSlider
   */
  max: _propTypes.default.number,

  /**
   * Set the RangeSlider as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Set the RangeSlider as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Form-validation: set the RangeSlider as required
   */
  required: _propTypes.default.bool,

  /**
   * Callback function onChange
   * Invoked AFTER new value had been set by the RangeSlider
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,

  /**
   * Display current value when hover the thumb
   */
  displayTooltip: _propTypes.default.bool,

  /**
   * Set the currency or number formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),

  /**
   * Display value en currency format.
   */
  displayCurrency: _propTypes.default.bool,

  /**
   * Add suffix after the number.
   */
  displaySuffix: _propTypes.default.string,

  /**
   * Callback function onKeyUp
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Display output value
   */
  edgeRightValue: _propTypes.default.bool,

  /**
   * Display min value on the left side
   */
  edgeMinValue: _propTypes.default.bool,

  /**
   * Display max value on the right side
   */
  edgeMaxValue: _propTypes.default.bool,

  /**
   * Set width of the track. Default 300px
   */
  widthTrack: _propTypes.default.string
};
RangeSlider.defaultProps = {
  helper: '',
  readOnly: false,
  disabled: false,
  required: false,
  name: 'single-range',
  min: 0,
  max: 100,
  value: 0,
  displayTooltip: true,
  displayCurrency: false,
  displaySuffix: '',
  edgeRightValue: true,
  edgeMinValue: false,
  edgeMaxValue: false,
  widthTrack: '300px',
  locale: 'en'
};
var _default = RangeSlider;
exports.default = _default;